import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-white text-dark text-center py-3">
      <p>&copy; 2024 Omega Review Solutions Pvt Ltd | All Rights Reserved</p>
    </footer>
  );
};

export default Footer;
